import React from 'react';

const AvatarCardLoader = () => {
    return (
        <div className="ori-tb-pad-10">
            <div className="ori-flex-column ori-flex-center ori-b-mrgn-10">
                <div className="ori-card-loading ori-b-mrgn-15 ori-box-75 ori-border-radius-half">&nbsp;</div>
                <p className="ori-card-loading ori-b-mrgn-5 ori-height-md width2">&nbsp;</p>
                <p className="ori-card-loading ori-b-mrgn-5 ori-height-xxs width3">&nbsp;</p>
                <p className="ori-card-loading ori-b-mrgn-5 ori-height-xxs width3">&nbsp;</p>
            </div>
            {
                [1, 2, 3, 4].map((i) => {
                    return (
                        <p key={i} className="ori-card-loading ori-tb-mrgn-5 ori-height-sm">&nbsp;</p>
                    );
                })
            }
            <div className="ori-flex-column ori-flex-center ori-t-mrgn-20">
                <p className="ori-card-loading ori-height-xxs width3">&nbsp;</p>
                <div className="ori-flex-row ori-flex-jc ori-flex-wrap ori-pad-5">
                    {
                        [1, 2, 3].map((i) => {
                            return (
                                <div key={i} className="ori-card-loading ori-lr-mrgn-5 ori-height-md ori-width-md">&nbsp;</div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default AvatarCardLoader;


// WEBPACK FOOTER //
// ./src/components/avatarcard/loader/index.js